import { computed } from "vue"

import { configDestinos } from "@/utils/destinosConfig"

export function useCotizadorComputed(
  destino,
  habitaciones
) {

  const showVisa = computed(() => {

    return destino.value.includes("JPN") || destino.value.includes("BKK")

  })

  const telefonoClass = computed(() => {

    return showVisa.value
      ? "col-md-3"
      : "col-md-6"

  })

  const destinoClass = computed(() => {

    if (destino.value.includes("COMBINADO")) {
      return "col-md-3"
    }

    if (
      ["PERU", "JPN", "JPN GUIA", "BKK"]
        .includes(destino.value)
    ) {
      return "col-md-4"
    }

    return "col-md-6"

  })

  const showDiasSimple = computed(() => {

    return [
      "PERU",
      "JPN",
      "JPN GUIA", "BKK"
    ].includes(destino.value)

  })

  const showDiasCombinado = computed(() => {

    return destino.value.includes("COMBINADO")

  })

  const configActual = computed(() => {

    return configDestinos[destino.value] || null

  })

  const opcionesDias = computed(() => {

    return configActual.value?.opciones || []

  })

  const labelsCombinado = computed(() => {

    return configActual.value?.labels || []

  })

  const minDias1 = computed(() => {

    return configActual.value?.min1 || 1

  })

  const minDias2 = computed(() => {

    return configActual.value?.min2 || 1

  })

  const colClass = computed(() => {

    const total = habitaciones.value.length

    switch (total) {

      case 1:
        return "col-md-12"

      case 2:
        return "col-md-6"

      case 3:
        return "col-md-4"

      case 4:
        return "col-md-3"

      default:
        return "col-md-12"

    }

  })

  return {

    showVisa,

    telefonoClass,

    destinoClass,

    showDiasSimple,

    showDiasCombinado,

    configActual,

    opcionesDias,

    labelsCombinado,

    minDias1,

    minDias2,

    colClass

  }

}